module.exports = __webpack_public_path__ + "static/media/iconMenuW.85088bc2.svg";